import { jsxs as j, jsx as n } from "react/jsx-runtime";
import r from "react";
import { useContextualStyle as W } from "../../Style/Style.js";
import { clsx as b } from "../../../utils/clsx.js";
import { mergeRefs as k } from "../../../utils/mergeRefs.js";
import { s as o, R as w } from "../../../Rail-CCuyJpf6.js";
const N = {
  size: 0,
  scrollPos: 0,
  scrollSize: 0
}, K = r.forwardRef(function(f, P) {
  const {
    children: y,
    className: A,
    onScroll: i,
    minThumbSize: S = 20,
    verticalAsHorizontal: a = !1
  } = f, e = r.useRef(null), u = r.useRef(null), [L, m] = r.useState(!1), [l, E] = r.useState(N), [T, g] = r.useState(0), [c, C] = r.useState(N), [I, X] = r.useState(0), Y = b(o.root, A, {
    [o.active]: L
  });
  r.useLayoutEffect(() => {
    if (!u.current)
      throw new Error("No scrollable content ref");
    const s = new ResizeObserver(() => {
      var t, d, h, v, p, x;
      C({
        size: ((t = e.current) == null ? void 0 : t.clientHeight) || 0,
        scrollPos: ((d = e.current) == null ? void 0 : d.scrollTop) || 0,
        scrollSize: ((h = e.current) == null ? void 0 : h.scrollHeight) || 0
      }), E({
        size: ((v = e.current) == null ? void 0 : v.clientWidth) || 0,
        scrollPos: ((p = e.current) == null ? void 0 : p.scrollLeft) || 0,
        scrollSize: ((x = e.current) == null ? void 0 : x.scrollWidth) || 0
      });
    });
    return s.observe(u.current), () => s.disconnect();
  }, []);
  const _ = r.useCallback(
    (s) => {
      e.current && (i == null || i(s), X(e.current.scrollTop), g(e.current.scrollLeft));
    },
    [a]
  );
  r.useEffect(() => {
    if (!a || !e.current)
      return;
    const s = (t) => {
      t.preventDefault(), t.stopPropagation(), e.current && (e.current.scrollLeft += t.deltaY);
    };
    return e.current.addEventListener("wheel", s), () => {
      var t;
      return (t = e.current) == null ? void 0 : t.removeEventListener("wheel", s);
    };
  }, [a]);
  const z = l.scrollSize - l.size > 1, R = c.scrollSize - c.size > 1, H = b(o.scroller, {
    [o["no-x-scroll"]]: !z,
    [o["no-y-scroll"]]: !R
  });
  return /* @__PURE__ */ j("div", { ref: P, style: W(), className: Y, children: [
    /* @__PURE__ */ n("div", { ref: k(e, f.scrollerRef), className: H, onScroll: _, children: /* @__PURE__ */ n("div", { ref: u, className: o.content, children: y }) }),
    R && /* @__PURE__ */ n(
      w,
      {
        rootRef: e,
        axis: "y",
        size: c.size,
        pos: I,
        scrollSize: c.scrollSize,
        setRootActive: m,
        minThumbSize: S
      }
    ),
    z && /* @__PURE__ */ n(
      w,
      {
        rootRef: e,
        axis: "x",
        size: l.size,
        pos: T,
        scrollSize: l.scrollSize,
        setRootActive: m,
        minThumbSize: S
      }
    )
  ] });
});
export {
  K as Scrollable
};
